// extracted by mini-css-extract-plugin
export default {"cell":"TableRowCell-cell-giPrj"};